import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

const PALETTE = [
  'bg-primary-bg text-primary dark:bg-primary/35 dark:text-white',
  'bg-violet-bg text-violet dark:bg-violet/35 dark:text-white',
  'bg-info-bg text-info dark:bg-info/35 dark:text-white',
  'bg-pos-bg text-positive dark:bg-positive/35 dark:text-white',
  'bg-caut-bg text-caution dark:bg-caution dark:text-topbar',
];

const SIZE_CLASSES = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-[11px]',
  lg: 'w-11 h-11 text-sm',
};

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="rounded-full flex items-center justify-center font-bold shrink-0 uppercase tracking-tight antialiased"
      [ngClass]="[sizeClass, colorClass]"
    >
      {{ initials }}
    </div>
  `,
})
export class AvatarComponent {
  @Input() name = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get initials(): string {
    const parts = this.name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2);
    return `${parts[0][0]}${parts[parts.length - 1][0]}`;
  }

  get sizeClass(): string {
    return SIZE_CLASSES[this.size];
  }

  get colorClass(): string {
    let hash = 0;
    for (let i = 0; i < this.name.length; i++) hash = (hash * 31 + this.name.charCodeAt(i)) >>> 0;
    return PALETTE[hash % PALETTE.length];
  }
}
